import axios from "axios";
import { toast } from "react-toastify";
import { SHA256 } from "crypto-js";
const axiosClient = axios.create();

// const authToken = localStorage.getItem("authToken")
//   ? JSON.parse(localStorage.getItem("authToken"))
//   : null;

const getToken = () => {
  return localStorage.getItem("authToken")
    ? JSON.parse(localStorage.getItem("authToken"))
    : null;
};
const AUTH_HEADERS = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authToken: getToken(),
    },
  };
};

const getOtpToken = () => {
  return localStorage.getItem("dup-authToken")
    ? JSON.parse(localStorage.getItem("dup-authToken"))
    : null;
};

const OTP_AUTH_HEADERS = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authToken: getOtpToken(),
    },
  };
};
// axiosClient.defaults.headers = {
//   "Content-Type": "application/json",
//   Accept: "application/json",
//   authToken,
// };

const { REACT_APP_BASE_URL, REACT_APP_NODE_ENV } = process.env;
console.log(
  `APplication url ${process.env.REACT_APP_BASE_URL} ${process.env.REACT_APP_NODE_ENV}`
);
let baseURL = "/api";
if (process.env.NODE_ENV === "development") {
  baseURL = "http://localhost:8000/api";
  // baseURL = "https://api.cloudcons.in/api";
}

if (REACT_APP_BASE_URL && REACT_APP_NODE_ENV && REACT_APP_NODE_ENV === "DEV") {
  baseURL = REACT_APP_BASE_URL;
}

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => error
);

export function getRequest(URL) {
  return axiosClient
    .get(`${baseURL}${URL}`, AUTH_HEADERS())
    .then((response) => response);
}

export function getRequestWithParams(URL, params = {}) {
  // Convert the params object to a query string
  const query = new URLSearchParams(params).toString();

  // Append the query string to the URL
  const fullURL = `${baseURL}${URL}?${query}`;

  return axiosClient.get(fullURL, AUTH_HEADERS()).then((response) => response);
}

export function postRequest(URL, payload) {
  return axiosClient
    .post(`${baseURL}${URL}`, payload, AUTH_HEADERS())
    .then((response) => response);
}

export function otpPostRequest(URL, payload) {
  return axiosClient
    .post(`${baseURL}${URL}`, payload, OTP_AUTH_HEADERS())
    .then((response) => response);
}

export function putRequest(URL, payload) {
  return axiosClient
    .put(`${baseURL}${URL}`, payload, AUTH_HEADERS())
    .then((response) => response);
}

export function deleteRequest(URL) {
  return axiosClient
    .delete(`${baseURL}${URL}`, AUTH_HEADERS())
    .then((response) => response);
}

// s3 upload
export async function uploadFileToS3(signedUrl, file, fileBlob) {
  try {
    // Convert the file to a Uint8Array
    const fileArrayBuffer = await file.arrayBuffer();
    const fileUint8Array = new Uint8Array(fileArrayBuffer);

    // Calculate the SHA-256 hash of the file content
    const sha256Hash = SHA256(fileUint8Array).toString();
    const formData = new FormData();
    formData.append("file", fileBlob);

    const response = await axiosClient.put(signedUrl, fileBlob, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
    });
    if (response.status === 200) {
      console.log("File uploaded successfully.");
      return response;
    } else {
      console.error("File upload failed:", response);
      return response;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    return error;
  }
}

export default axiosClient;
